const PDFPageEditorOptInPanelEnum = {
  PDF_PAGE_EDITOR_OPT_IN_PANEL_SET_PAGES_FROM_FILE: 'PDF_PAGE_EDITOR_OPT_IN_PANEL_SET_PAGES_FROM_FILE',
};

export default PDFPageEditorOptInPanelEnum;



// WEBPACK FOOTER //
// ./src-react/PDFPageEditorOptInPanel/PDFPageEditorOptInPanelConstants.jsx